import { useSortedTags } from 'features/tags';
import { useClearAllTasksFilters } from 'features/user';
import { useExistingFilterTags } from 'pages/all-tasks/hooks/use-existing-filter-tags';
import React, { useEffect, useMemo } from 'react';
import { FilterBannerBase } from 'shared/components/ui/filter-banner-base';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';

import { FilterContextMenu } from '../filter-context-menu';
import * as Styled from './active-filter-banner.style';

export const ActiveFilterBanner: React.FC = () => {
  const tags = useSortedTags();
  const clearFilters = useClearAllTasksFilters();

  const {
    open: openMenu,
    close: closeMenu,
    position: menuPosition,
  } = useContextMenuState();

  const activeFilterTags = useExistingFilterTags();

  const filteredTags = useMemo(
    () =>
      activeFilterTags.length
        ? tags.filter(({ id }) => activeFilterTags.includes(id))
        : [],
    [activeFilterTags, tags],
  );

  useEffect(() => {
    if (!filteredTags.length) {
      closeMenu();
    }
  }, [closeMenu, filteredTags.length]);

  return (
    <Styled.Container $open={!!filteredTags.length}>
      <FilterBannerBase
        tags={filteredTags}
        onTags={openMenu}
        onClear={clearFilters}
      />

      {!!menuPosition && (
        <FilterContextMenu onClose={closeMenu} location={menuPosition} />
      )}
    </Styled.Container>
  );
};
